<div class="detail-panel-root scroll-oscuro flex-1 overflow-y-auto p-6 md:p-8 pb-16" style="background: var(--bg-main)">
  <div class="flex justify-between items-start gap-4 mb-5">
    <div>
      <span class="badge-id font-mono text-[11px] px-2.5 py-0.5 rounded-md inline-block mb-2">
        {{ producto.id }}
      </span>
      <h2 class="text-[21px] font-bold mb-1" style="color: var(--text-primary)">{{ producto.mueble }}</h2>
      <div class="text-[12.5px] flex items-center gap-2" style="color: var(--text-secondary)">
        <span>{{ producto.categoria }} · {{ proveedorNombre }}</span>
        <button type="button" (click)="abrirEdicionNombreProveedor()"
                class="shrink-0 text-[13px] leading-none" title="Editar nombre del proveedor" aria-label="Editar nombre del proveedor">
          ✏️
        </button>
        @if (proveedorFotoTarjetaUrl) {
          <button type="button" (click)="abrirTarjetaProveedor()"
                  class="swatch w-6 h-6 rounded overflow-hidden shrink-0" title="Ver tarjeta del proveedor">
            <app-foto-remota [url]="proveedorFotoTarjetaUrl" alt="Tarjeta del proveedor" className="w-full h-full object-cover" />
          </button>
        }
      </div>
      @if (puedeEditar) {
        <button type="button" (click)="mostrarBorrarProveedor.set(true)"
                class="flex items-center gap-1.5 text-[11.5px] font-semibold px-2.5 py-1.5 rounded-lg mt-1"
                style="color: var(--jamar-red); border: 1px solid var(--jamar-red)">
          🗑 Eliminar este proveedor (y todos sus productos)
        </button>
      }
    </div>
    @if (producto.rango || producto.fob !== undefined) {
      <span class="badge-price text-[11px] font-bold px-3 py-1.5 rounded-full whitespace-nowrap">
        @if (producto.rango) {
          Rango {{ producto.rango }} ·
        }
        @if (producto.fob !== undefined) {
          FOB ${{ producto.fob }} USD
        }
      </span>
    }
  </div>

  @if (producto.atributosEspeciales.length > 0) {
    <div class="flex flex-wrap gap-1.5 mb-5">
      @for (a of producto.atributosEspeciales; track a) {
        <span class="tag text-[10px] font-mono uppercase tracking-wide px-2 py-1 rounded">
          {{ a }}
        </span>
      }
    </div>
  }

  @if (primeraTela) {
    <div class="flex gap-2 mb-6">
      @for (c of coloresTelaFondo; track c) {
        <div class="swatch w-16 h-16 rounded-lg" [style.background]="c"></div>
      }
      @if (primeraTela.fotoFrenteUrl) {
        <button type="button" (click)="abrirFotoTela(primeraTela, 'frente')"
                class="swatch w-16 h-16 rounded-lg overflow-hidden">
          <app-foto-remota [url]="primeraTela.fotoFrenteUrl" alt="Frente de tela" className="w-full h-full object-cover" />
        </button>
      }
      @if (primeraTela.fotoReversoUrl) {
        <button type="button" (click)="abrirFotoTela(primeraTela, 'reverso')"
                class="swatch w-16 h-16 rounded-lg overflow-hidden">
          <app-foto-remota [url]="primeraTela.fotoReversoUrl" alt="Reverso de tela" className="w-full h-full object-cover" />
        </button>
      }
    </div>
  }

  @if (producto.fotos && producto.fotos.length > 0) {
    <p class="section-label font-mono text-[11px] uppercase tracking-wide mb-3">
      Fotos del producto ({{ producto.fotos.length }})
    </p>
    <div class="flex flex-wrap gap-2 mb-6">
      @for (f of producto.fotos; track f.url; let i = $index) {
        <button type="button" (click)="abrirFotoProducto(i)"
                class="swatch w-20 h-20 rounded-lg overflow-hidden">
          <app-foto-remota [url]="f.url" [alt]="f.etiqueta || 'Foto del producto'" className="w-full h-full object-cover" />
        </button>
      }
    </div>
  }

  <p class="section-label font-mono text-[11px] uppercase tracking-wide mb-3">
    Fichas de tela ({{ producto.telas.length }})
  </p>
  @for (t of producto.telas; track t.id) {
    <div class="card flex gap-3.5 items-center px-4 py-3 mb-2.5">
      <div class="flex gap-1.5">
        @if (t.fotoFrenteUrl) {
          <button type="button" (click)="abrirFotoTela(t, 'frente')"
                  class="swatch w-[38px] h-[38px] rounded-lg overflow-hidden">
            <app-foto-remota [url]="t.fotoFrenteUrl" alt="Frente de tela" className="w-full h-full object-cover" />
          </button>
        } @else {
          <div class="swatch w-[38px] h-[38px] rounded-lg" [style.background]="t.colorFrente || 'var(--jamar-red-soft)'"></div>
        }
        @if (t.fotoReversoUrl) {
          <button type="button" (click)="abrirFotoTela(t, 'reverso')"
                  class="swatch w-[38px] h-[38px] rounded-lg overflow-hidden">
            <app-foto-remota [url]="t.fotoReversoUrl" alt="Reverso de tela" className="w-full h-full object-cover" />
          </button>
        } @else {
          <div class="swatch w-[38px] h-[38px] rounded-lg" [style.background]="t.colorReverso || 'var(--surface-hover)'"></div>
        }
      </div>
      <div class="flex-1 min-w-0">
        <div class="fabric-id text-[10.5px]">{{ t.id }} · Muestrario {{ t.muestrario }}</div>
        <div class="text-[13.5px] font-bold mt-0.5" style="color: var(--text-primary)">{{ t.colores }}</div>
        <div class="text-[11.5px]" style="color: var(--text-secondary)">{{ t.tipo }}</div>
      </div>
      @if (puedeEditar) {
        <button type="button" (click)="telaABorrar.set(t)" class="shrink-0 text-[13px]" title="Eliminar esta tela" aria-label="Eliminar esta tela">
          🗑
        </button>
      }
    </div>
  }

  @if (puedeEditar) {
    <p class="section-label font-mono text-[11px] uppercase tracking-wide mt-6 mb-3">
      Fotos (adjuntar / reemplazar desde el dashboard)
    </p>
    <div class="card p-4 mb-3">
      <div class="flex flex-wrap gap-6">
        <div>
          <p class="text-[11px] font-semibold mb-1.5" style="color: var(--text-secondary)">Tarjeta del proveedor</p>
          <app-campo-foto-dashboard
            [slot]="slotTarjetaProveedor"
            [url]="proveedorFotoTarjetaUrl"
            titulo="Tarjeta del proveedor"
            [puedeEditar]="true"
            (actualizado)="alActualizarFotoDashboard()"
          />
        </div>
        <div>
          <p class="text-[11px] font-semibold mb-1.5" style="color: var(--text-secondary)">Color de estructura</p>
          <app-campo-foto-dashboard
            [slot]="slotColorEstructura"
            [url]="producto.colorEstructuraFotoUrl"
            titulo="Color de estructura"
            [puedeEditar]="true"
            (actualizado)="alActualizarFotoDashboard()"
          />
        </div>
        @for (t of producto.telas; track t.id) {
          <div>
            <p class="text-[11px] font-semibold mb-1.5" style="color: var(--text-secondary)">Tela {{ t.muestrario }} · Frente</p>
            <app-campo-foto-dashboard
              [slot]="slotTelaFrente(t)"
              [url]="t.fotoFrenteUrl"
              titulo="Frente de tela"
              [puedeEditar]="true"
              (actualizado)="alActualizarFotoDashboard()"
            />
          </div>
          <div>
            <p class="text-[11px] font-semibold mb-1.5" style="color: var(--text-secondary)">Tela {{ t.muestrario }} · Reverso</p>
            <app-campo-foto-dashboard
              [slot]="slotTelaReverso(t)"
              [url]="t.fotoReversoUrl"
              titulo="Reverso de tela"
              [puedeEditar]="true"
              (actualizado)="alActualizarFotoDashboard()"
            />
          </div>
        }
      </div>
    </div>
  }

  <p class="section-label font-mono text-[11px] uppercase tracking-wide mt-6 mb-3">
    Completar (Director de categoría)
  </p>
  @if (!puedeEditar) {
    <p class="text-[11.5px] mb-3 flex items-center gap-1.5" style="color: var(--jamar-red)">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 0 1 8 0v3" />
      </svg>
      Tu rol ({{ rolActual }}) no tiene permiso para completar esta ficha.
    </p>
  }
  <div class="card p-4">
    <div class="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-3.5">
      <div>
        <label for="detalle-nombre-comercial" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Nombre comercial
        </label>
        <input
          id="detalle-nombre-comercial"
          [ngModel]="nombreComercial()"
          (ngModelChange)="nombreComercial.set($event)"
          [disabled]="!puedeEditar"
          placeholder="Ej. Butaca Vera Verde"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
      </div>
      <div>
        <label for="detalle-precio-colombia" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Precio venta Colombia
        </label>
        <input
          id="detalle-precio-colombia"
          [ngModel]="precioVentaCol()"
          (ngModelChange)="precioVentaCol.set($event)"
          [disabled]="!puedeEditar"
          inputmode="decimal"
          placeholder="Ej. 748000"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
        @if (formatoCop(precioVentaCol()); as f) {
          <p class="text-[11px] mt-1" style="color: var(--text-secondary)">$ {{ f }} COP</p>
        }
      </div>
      <div>
        <label for="detalle-precio-panama" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Precio venta Panamá
        </label>
        <input
          id="detalle-precio-panama"
          [ngModel]="precioVentaPan()"
          (ngModelChange)="precioVentaPan.set($event)"
          [disabled]="!puedeEditar"
          inputmode="decimal"
          placeholder="Ej. 210"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
        @if (esNumeroValido(precioVentaPan())) {
          <p class="text-[11px] mt-1" style="color: var(--text-secondary)">$ {{ precioVentaPan() }} USD</p>
        }
      </div>
      <div>
        <label for="detalle-categoria" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Categoría
        </label>
        <input
          id="detalle-categoria"
          [ngModel]="categoria()"
          (ngModelChange)="categoria.set($event)"
          [disabled]="!puedeEditar"
          placeholder="Ej. Social"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
      </div>
      <div>
        <label for="detalle-linea" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Línea
        </label>
        <input
          id="detalle-linea"
          [ngModel]="linea()"
          (ngModelChange)="linea.set($event)"
          [disabled]="!puedeEditar"
          placeholder="Ej. Salas"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
      </div>
      <div>
        <label for="detalle-sublinea" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Sublínea
        </label>
        <input
          id="detalle-sublinea"
          [ngModel]="sublinea()"
          (ngModelChange)="sublinea.set($event)"
          [disabled]="!puedeEditar"
          placeholder="Ej. Butaca"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
      </div>
      <div>
        <label for="detalle-unidades-contenedor" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Unidades/contenedor
        </label>
        <input
          id="detalle-unidades-contenedor"
          [ngModel]="unidadesPorContenedor()"
          (ngModelChange)="unidadesPorContenedor.set($event)"
          [disabled]="!puedeEditar"
          inputmode="numeric"
          placeholder="Ej. 100"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px]"
        />
        @if (producto.moq !== undefined) {
          <p class="text-[11px] mt-1" style="color: var(--text-secondary)">MOQ capturado: {{ producto.moq }}</p>
        }
      </div>
      <div class="md:col-span-3">
        <label for="detalle-notas" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">Notas</label>
        <textarea id="detalle-notas" [ngModel]="notas()" (ngModelChange)="notas.set($event)" [disabled]="!puedeEditar"
                  placeholder="Medidas, material, observaciones…"
                  class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px] min-h-16"></textarea>
      </div>
    </div>
  </div>

  <div class="flex items-center gap-3 mt-5">
    <button (click)="guardar()" [disabled]="!puedeEditar || guardando()"
            class="btn-primary text-[13px] font-semibold px-4 py-2.5 rounded-lg">
      {{ guardando() ? 'Guardando…' : 'Guardar cambios' }}
    </button>
    <span [class]="'toast-ok text-[12px] font-semibold transition-opacity ' + (mostrarToast() ? 'opacity-100' : 'opacity-0')">
      ✓ Guardado
    </span>
    @if (puedeEditar) {
      <button type="button" (click)="mostrarBorrarProducto.set(true)"
              class="text-[12.5px] font-semibold px-3 py-2 rounded-lg ml-auto" style="color: var(--jamar-red); border: 1px solid var(--jamar-red)">
        🗑 Eliminar este producto
      </button>
    }
  </div>

  @if (editandoNombreProveedor()) {
    <div class="fixed inset-0 z-[80] bg-black/45 flex items-center justify-center p-4">
      <div class="w-full max-w-sm rounded-2xl border border-[var(--border)] p-4" style="background: var(--bg-main)">
        <label for="editar-nombre-proveedor-dashboard" class="field-label block text-[10.5px] font-bold uppercase tracking-wide mb-1.5">
          Nombre del proveedor
        </label>
        <input
          id="editar-nombre-proveedor-dashboard"
          [ngModel]="nombreProveedorEditado()"
          (ngModelChange)="nombreProveedorEditado.set($event)"
          placeholder="Nombre del proveedor"
          class="field-input w-full rounded-lg px-3 py-2.5 text-[13.5px] mb-3"
        />
        <div class="flex items-center gap-2.5">
          <button type="button" (click)="cerrarEdicionNombreProveedor()"
                  class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
            Cancelar
          </button>
          <button type="button" (click)="guardarNombreProveedor()" [disabled]="guardandoNombreProveedor()"
                  class="btn-primary flex-1 text-[13px] font-bold py-2.5 rounded-lg">
            {{ guardandoNombreProveedor() ? 'Guardando…' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>
  }

  @if (imagenAmpliada(); as img) {
    <app-visor-imagen
      [url]="img.url"
      [titulo]="img.titulo"
      [puedeAnterior]="puedeImagenAnterior()"
      [puedeSiguiente]="puedeImagenSiguiente()"
      (cerrar)="cerrarImagen()"
      (anterior)="imagenAnterior()"
      (siguiente)="imagenSiguiente()"
    />
  }

  @if (mostrarBorrarProducto()) {
    <app-confirmar-borrado-modal
      titulo="Eliminar producto"
      mensaje="Esto también elimina todas sus telas guardadas. No se puede deshacer."
      [codigoConfirmacion]="producto.id"
      [accion]="accionBorrarProducto"
      (cerrar)="mostrarBorrarProducto.set(false)"
      (eliminado)="alEliminarProducto()"
    />
  }

  @if (mostrarBorrarProveedor()) {
    <app-confirmar-borrado-modal
      titulo="Eliminar proveedor"
      mensaje="Esto también elimina TODOS los productos y telas de este proveedor. No se puede deshacer."
      [codigoConfirmacion]="producto.proveedorCodigo"
      [accion]="accionBorrarProveedor"
      (cerrar)="mostrarBorrarProveedor.set(false)"
      (eliminado)="alEliminarProveedor()"
    />
  }

  @if (telaABorrar(); as t) {
    <app-confirmar-borrado-modal
      titulo="Eliminar tela"
      mensaje="Esta ficha de tela se eliminará por completo. No se puede deshacer."
      [codigoConfirmacion]="t.id"
      [accion]="accionBorrarTela(t)"
      (cerrar)="telaABorrar.set(null)"
      (eliminado)="alEliminarTela()"
    />
  }
</div>
